import { useState } from "react";
import { FieldsLayout } from "./layout";
import FieldSyncLogsContent from "../field-sync-logs";

const FieldLogsPage = () => {
  const [refreshFn, setRefreshFn] = useState<(() => void) | undefined>();
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefreshReady = (fn: () => void, refreshing: boolean) => {
    setRefreshFn(() => fn);
    setIsRefreshing(refreshing);
  };

  return (
    <FieldsLayout onRefresh={refreshFn} isRefreshing={isRefreshing}>
      <FieldSyncLogsContent onRefreshReady={handleRefreshReady} />
    </FieldsLayout>
  );
};

export default FieldLogsPage;
